export const RECURRING_PAYMENT = 'RecurringPayment';
export const ONE_TIME_PAYMENT = 'OneTimePayment';

export const isAutoPayInstrument = (instrument = {}, autopay = false) => (
  getAreInstrumentsEqual(instrument, autopay?.instrument)
);

// TODO: This probably won't work on review.
const commonFields = {
  ApplePay: [],
  Bank: ['bankAccountType', ['bankAccountNumber', 'bankAccountLast4Digits']],
  PaymentCard: ['cardType', ['last4DigitsCardNumber', 'cardLast4Digits'], 'expirationDate'],
};

export const getAreInstrumentsEqual = (a, b) => {
  if (!a || !b || a.type !== b.type || !commonFields[a.type]) return false;
  if (!commonFields[a.type].length) return true;
  return !commonFields[a.type].some((key) => {
    if (Array.isArray(key)) {
      return !key.some(k1 => key.some(k2 => (
        k1 in a && k2 in b && a[k1] === b[k2]
      )));
    }
    return a[key] !== b[key];
  });
};

export const isBlockedInstrument = (instruments, instrument) => (
  (instrument.type === 'PaymentCard' && instruments.cardblockStatus)
  || (instrument.type === 'Bank' && instruments.bankblockStatus)
);

export const canUseInstrument = (options, instrument) => !options || !!(options.find(option => (
  (instrument.bankAccountType && instrument.bankAccountType === option.bankAccountType)
  || (instrument.cardType && instrument.cardType === option.cardType)
)));

export const sortAutoPayFirst = (instruments = [], autopay = {}) => (
  instruments.reduce((sortedInstruments, instrument) => {
    if (isAutoPayInstrument(instrument, autopay)) {
      sortedInstruments.unshift(instrument);
    } else {
      sortedInstruments.push(instrument);
    }

    return sortedInstruments;
  }, [])
);

export const isNewMethod = paymentMethodOption => (
  paymentMethodOption === 'Bank' || paymentMethodOption === 'PaymentCard'
);

// Builds an instrument object from CPC data based on which details are provided
export function buildInstrumentFromCpcData(cardDetails, bankDetails) {
  if (bankDetails.token !== null) {
    return {
      bankAccountType: 'Bank Account',
      bankAccountNumber: bankDetails.bankAccountLast4Digits,
      type: 'Bank',
    };
  }
  if (cardDetails.token !== null) {
    return {
      cardType: cardDetails.cardType,
      last4DigitsCardNumber: cardDetails.cardLast4Digits,
      type: 'PaymentCard',
    };
  }
  throw new Error('No valid card or bank details provided');
}

// Returns a success message string for a newly added payment instrument (bank or card)
export function getInstrumentSuccessMessage(instrument) {
  if (instrument.type === 'Bank') {
    return `${instrument.bankAccountType} ending in ${instrument.bankAccountNumber} was added successfully.`;
  }
  // Default to card
  return `${instrument.cardType} ending in ${instrument.last4DigitsCardNumber} was added successfully.`;
}
